// extracted by mini-css-extract-plugin
export default {"image":"carModelSlideshow_image__HX9Xi","container":"carModelSlideshow_container__ujOKY","scroll":"carModelSlideshow_scroll__4ke+D","down":"carModelSlideshow_down__JAGo9"};